import uuid from 'uuid/v1';
import {
    COMPARISON_OPERATOR,
    ENTITY_TYPE,
    FIELD_NAME,
    LOGICAL_OPERATOR,
} from 'modules/push-api/utils/subscriptionConsts';

export const pushApiSubscriptionInitialValues = {
    accountId: null,
    name: null,
    entities: [
        {
            id: uuid(),
            type: ENTITY_TYPE.CAMPAIGN,
            endpointUrl: null,
            fetchEntity: 0,
            policyId: '1',
            logicalOperator: LOGICAL_OPERATOR.OR,
            fields: [
                {
                    id: uuid(),
                    name: FIELD_NAME.CAMPAIGN_NAME,
                    logicalOperator: LOGICAL_OPERATOR.OR,
                    filters: [
                        {
                            id: uuid(),
                            newValueCriterion: null,
                            newComparisonOperatorCriterion: COMPARISON_OPERATOR.ALWAYS_TRUE,
                            logicalOperator: LOGICAL_OPERATOR.AND,
                            previousValueCriterion: null,
                            previousComparisonOperatorCriterion: COMPARISON_OPERATOR.ALWAYS_TRUE,
                        },
                    ],
                },
            ],
        },
    ],
};
